<div *ngIf="isLoading" class="spinnerDialog">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<div class="container">
  <div *ngIf="!isLoading">
    <h2>Asignación de Proveedores</h2>
    <h3>File {{ data?.productAventura?.fileNumber }}</h3>
    <div class="restriction-info" *ngIf="communityRestrictionText">
      <mat-icon
        style="
          font-size: 20px;
          width: 20px;
          height: 20px;
          vertical-align: middle;
          margin-right: 4px;
        "
        >info</mat-icon
      >
      <span
        ><strong>Restricciones de comunidad:</strong>
        {{ communityRestrictionText }}</span
      >
    </div>
  </div>

  <div class="mat-elevation-z8" *ngIf="dataSource.data.length > 0">
    <mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="ssff">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-chip-list *ngIf="element.ssffproduct">
            <mat-chip color="primary" selected>SSFF</mat-chip>
          </mat-chip-list>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="days">
        <mat-header-cell *matHeaderCellDef>Día</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="day-badge">{{
            element?.days?.length > 1
              ? element.days[0] + " - " + element.days[element.days.length - 1]
              : element.days[0]
          }}</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="nombreServicio">
        <mat-header-cell *matHeaderCellDef>Nombre</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="service-name-cell">
            <span class="service-name-title">{{ element?.nombreServicio }}</span>
            <span
              *ngIf="getOsStatusText(element)"
              class="os-subtle-badge"
              [title]="getOsTooltip(element)"
            >
              {{ getOsStatusText(element) }}
            </span>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="tipoServicio">
        <mat-header-cell *matHeaderCellDef>Tipo</mat-header-cell>
        <mat-cell *matCellDef="let element">{{
          element?.tipoServicio
        }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="categoriaServicio">
        <mat-header-cell *matHeaderCellDef>Categoría</mat-header-cell>
        <mat-cell *matCellDef="let element">{{
          element?.categoriaServicio != "null"
            ? element?.categoriaServicio
            : "-"
        }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="cantidad">
        <mat-header-cell *matHeaderCellDef>Cantidad</mat-header-cell>
        <mat-cell *matCellDef="let element">{{
          element?.cantPersonal
        }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="proveedor">
        <mat-header-cell *matHeaderCellDef>Proveedor</mat-header-cell>
        <mat-cell
          *matCellDef="let element; let i = index"
          style="display: block"
        >
          <mat-form-field
            [ngStyle]="{ display: displaySelection ? 'block' : 'none' }"
          >
            <mat-select
              [(ngModel)]="element.proveedores"
              [compareWith]="compareProviders"
              placeholder="Seleccionar"
              multiple
              (selectionChange)="changed(element)"
              (openedChange)="onProviderDropdownOpened($event, element, i)"
              panelClass="custom-filter-select-panel"
              #selectProveedor
            >
              <mat-select-trigger>
                <span
                  *ngIf="element.proveedores && element.proveedores.length > 0"
                >
                  {{ element.proveedores[0]?.nombre }}
                  <span
                    *ngIf="
                      element.proveedores && element.proveedores.length > 1
                    "
                    class="trigger-extra-count"
                  >
                    (+{{ element.proveedores.length - 1 }})
                  </span>
                </span>
                <span
                  *ngIf="
                    !element.proveedores || element.proveedores.length === 0
                  "
                  class="select-trigger-placeholder"
                >
                  Seleccionar
                </span>
              </mat-select-trigger>

              <div
                class="select-search-header"
                (click)="$event.stopPropagation()"
                (keydown)="onSearchKeydown($event, element, selectProveedor)"
              >
                <div class="select-search-box">
                  <i-tabler name="search" class="search-box-icon"></i-tabler>
                  <input
                    id="search-provider-input-{{ i }}"
                    type="text"
                    class="select-search-input"
                    placeholder="Buscar proveedor o comunidad..."
                    [ngModel]="element.searchQuery"
                    (ngModelChange)="onSearchProvider(element, $event)"
                    (click)="$event.stopPropagation()"
                    autocomplete="off"
                  />
                  <button
                    *ngIf="element.searchQuery"
                    type="button"
                    class="select-search-clear-btn"
                    (click)="clearSearchProvider(element, $event)"
                    title="Limpiar búsqueda"
                  >
                    <i-tabler name="x"></i-tabler>
                  </button>
                </div>
              </div>

              <ng-container
                *ngIf="
                  element.filteredProviders?.length > 0;
                  else noProveedores
                "
              >
                <mat-option
                  *ngFor="let proveedor of element.filteredProviders"
                  [value]="proveedor"
                  class="provider-option"
                  [hidden]="!isProviderVisible(proveedor, element.searchQuery)"
                >
                  <div class="provider-option-content">
                    <div class="provider-name-row">
                      <span class="provider-name">{{ proveedor.nombre }}</span>
                      <span
                        class="provider-os-badge"
                        *ngIf="isProviderWithOS(element, proveedor.id)"
                        title="Ya cuenta con Orden de Servicio"
                      >
                        Con OS
                      </span>
                    </div>
                    <span
                      class="provider-community"
                      *ngIf="proveedor?.personalCampoInfo?.comunidad"
                    >
                      {{ proveedor.personalCampoInfo.comunidad }}
                    </span>
                  </div>
                </mat-option>

                <div
                  *ngIf="!hasVisibleProviders(element)"
                  class="select-empty-message"
                >
                  No se encontraron coincidencias para "{{
                    element.searchQuery
                  }}"
                </div>
              </ng-container>
              <ng-template #noProveedores>
                <mat-option disabled>No hay proveedores</mat-option>
              </ng-template>
            </mat-select>
          </mat-form-field>

          <div
            [ngClass]="{ 'hover-content': displaySelection }"
            *ngIf="element.allProv?.length > 0; else dash"
            class="assigned-providers-list"
          >
            <div class="provider-tag" *ngFor="let proveedor of element.allProv">
              <mat-icon class="provider-icon">person</mat-icon>
              <div class="provider-details">
                <div class="provider-name-row">
                  <span class="p-name">{{ proveedor.nombre }}</span>
                  <span
                    class="provider-os-badge"
                    *ngIf="isProviderWithOS(element.serviceId, proveedor.id)"
                    title="Ya cuenta con Orden de Servicio"
                  >
                    Con OS
                  </span>
                </div>
                <span
                  class="p-comm"
                  *ngIf="proveedor?.personalCampoInfo?.comunidad"
                >
                  {{ proveedor.personalCampoInfo.comunidad }}
                </span>
              </div>
            </div>
          </div>
          <ng-template #dash>
            <div *ngIf="!displaySelection" class="empty-dash">
              <span>-</span>
            </div>
          </ng-template>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
  </div>
  <div [hidden]="dataSource.data.length === 0">
    <mat-paginator
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons
    ></mat-paginator>
  </div>

  <mat-dialog-actions
    *ngIf="!isLoading"
    align="center"
    class="actions-container"
  >
    <button mat-stroked-button mat-dialog-close class="btn-cancel">
      Cancelar
    </button>
    <button mat-raised-button class="btn-save" (click)="guardar()">
      Aceptar
    </button>
  </mat-dialog-actions>
</div>
